/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyTagLocationTypeRule
 */
export interface ShopifyTagLocationTypeRule {
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyTagLocationTypeRule
   */
  tags: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ShopifyTagLocationTypeRule
   */
  locationType: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyTagLocationTypeRule
   */
  distributionWarehouseBrand?: string | null;
}

/**
 * Check if a given object implements the ShopifyTagLocationTypeRule interface.
 */
export function instanceOfShopifyTagLocationTypeRule(
  value: object,
): value is ShopifyTagLocationTypeRule {
  if (!("tags" in value) || value["tags"] === undefined) return false;
  if (!("locationType" in value) || value["locationType"] === undefined)
    return false;
  return true;
}

export function ShopifyTagLocationTypeRuleFromJSON(
  json: any,
): ShopifyTagLocationTypeRule {
  return ShopifyTagLocationTypeRuleFromJSONTyped(json, false);
}

export function ShopifyTagLocationTypeRuleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyTagLocationTypeRule {
  if (json == null) {
    return json;
  }
  return {
    tags: json["tags"],
    locationType: json["locationType"],
    distributionWarehouseBrand:
      json["distributionWarehouseBrand"] == null
        ? undefined
        : json["distributionWarehouseBrand"],
  };
}

export function ShopifyTagLocationTypeRuleToJSON(
  json: any,
): ShopifyTagLocationTypeRule {
  return ShopifyTagLocationTypeRuleToJSONTyped(json, false);
}

export function ShopifyTagLocationTypeRuleToJSONTyped(
  value?: ShopifyTagLocationTypeRule | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    tags: value["tags"],
    locationType: value["locationType"],
    distributionWarehouseBrand: value["distributionWarehouseBrand"],
  };
}
